import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import clsx from 'clsx'

function OpalLink ({ to, className, style, children }) {
  return (
    <Link className={clsx('opal-link', className)} style={style} to={to}>{children}</Link>
  )
}

OpalLink.propTypes = {
  to: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node
}

export default OpalLink
